import ResourcesFilter from "./ResourcesFilter";

export default class ResourcesNavigationFilter extends ResourcesFilter {
    init() {
        this.navigationLink = document.querySelectorAll(".js-nav-resources-item");

        this.initFilters();
    }

    initFilters() {
        if (this.navigationLink) {
            this.navigationLink.forEach((item) => {
                item.addEventListener("click", (event) => {
                    event.preventDefault();

                    if (event.target) {
                        let current = event.target;

                        let slug = current.getAttribute("data-category");

                        this.ajaxFilter(slug);
                    }
                });
            });
        }
    }

    ajaxFilter(slug, page = 1, stateHistory = true) {
        let url = this.getApiUrlFromElement(".js-nav-resources-api");

        let params = "?page=" + page;

        if (slug) {
            params += "&resource-category=" + slug;
        }

        this.loadAjax(url, params, stateHistory);
    }

    afterFilterAjax(response, stateHistory) {
        let data = JSON.parse(response);

        if (data.url && stateHistory) {
            let stateData = {
                page: data.page,
                url: data.url,
                random: Math.random(),
                source: "swup",
            };

            this.updateUrls(stateData, data.url);
        }

        window.location = data.url;
    }
}
